/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiReviewRequestEntityType } from './InternalApiReviewRequestEntityType';
import {
    InternalApiReviewRequestEntityTypeFromJSON,
    InternalApiReviewRequestEntityTypeFromJSONTyped,
    InternalApiReviewRequestEntityTypeToJSON,
    InternalApiReviewRequestEntityTypeToJSONTyped,
} from './InternalApiReviewRequestEntityType';
import type { InternalApiReviewStatus } from './InternalApiReviewStatus';
import {
    InternalApiReviewStatusFromJSON,
    InternalApiReviewStatusFromJSONTyped,
    InternalApiReviewStatusToJSON,
    InternalApiReviewStatusToJSONTyped,
} from './InternalApiReviewStatus';

/**
 * 
 * @export
 * @interface InternalApiResolveReviewRequest
 */
export interface InternalApiResolveReviewRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalApiResolveReviewRequest
     */
    entityId: string;
    /**
     * 
     * @type {InternalApiReviewRequestEntityType}
     * @memberof InternalApiResolveReviewRequest
     */
    entityType: InternalApiReviewRequestEntityType;
    /**
     * 
     * @type {InternalApiReviewStatus}
     * @memberof InternalApiResolveReviewRequest
     */
    status: InternalApiReviewStatus;
}



/**
 * Check if a given object implements the InternalApiResolveReviewRequest interface.
 */
export function instanceOfInternalApiResolveReviewRequest(value: object): value is InternalApiResolveReviewRequest {
    if (!('entityId' in value) || value['entityId'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function InternalApiResolveReviewRequestFromJSON(json: any): InternalApiResolveReviewRequest {
    return InternalApiResolveReviewRequestFromJSONTyped(json, false);
}

export function InternalApiResolveReviewRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiResolveReviewRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'entityId': json['entityId'],
        'entityType': InternalApiReviewRequestEntityTypeFromJSON(json['entityType']),
        'status': InternalApiReviewStatusFromJSON(json['status']),
    };
}

export function InternalApiResolveReviewRequestToJSON(json: any): InternalApiResolveReviewRequest {
    return InternalApiResolveReviewRequestToJSONTyped(json, false);
}

export function InternalApiResolveReviewRequestToJSONTyped(value?: InternalApiResolveReviewRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityId': value['entityId'],
        'entityType': InternalApiReviewRequestEntityTypeToJSON(value['entityType']),
        'status': InternalApiReviewStatusToJSON(value['status']),
    };
}

